import "./Gallery.css";

import img1 from "../../assets/img/Slideshow/img1.jpg"
import img2 from "../../assets/img/Slideshow/img2.jpg"
import img3 from "../../assets/img/Slideshow/img3.jpg"
import img4 from "../../assets/img/Slideshow/img4.jpg"

const Gallery = () => {

    return (
        <div id="gallery">
            <img src={img1} alt="plat1" />
            <img src={img2} alt="plat2" />
            <img src={img3} alt="plat3" />
            <img src={img4} alt="plat4" />
        </div>
    );
};

export default Gallery;